"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLORS = exports.SPACING = exports.RADIUS = exports.SHADOW = exports.BREAKPOINT = exports.BORDER = exports.FONT_FAMILIES = void 0;
exports.FONT_FAMILIES = {
    condensed: 'VP Condensed Next, Impact, arial, sans-serif',
    marianne: 'Marianne, arial, sans-serif',
    text: 'HK Grotesk, arial, sans-serif',
    title: 'VP Next, arial, sans-serif',
};
exports.BORDER = {
    s100: '1px',
    s200: '2px',
};
exports.BREAKPOINT = {
    tablet: '641px',
    tabletMedium: '769px',
    desktop: '1025px',
    desktopHD: '1221px',
};
exports.SHADOW = {
    z1: '0 -1px 1px -1px rgba(34,34,43,0.08), 0 4px 8px -2px rgba(34,34,43,0.08), 0 1px 10px -2px rgba(34,34,43,0.10)',
    z2: '0 -1px 1px -1px rgba(34,34,43,0.12), 0 10px 14px -6px rgba(34,34,43,0.06), 0 4px 16px -4px rgba(34,34,43,0.12)',
    z3: '0 -1px 2px -2px rgba(34,34,43,0.16), 0 10px 14px -6px rgba(34,34,43,0.08), 0 4px 18px -2px rgba(34,34,43,0.10)',
    z4: '0 -1px 4px -2px rgba(34,34,43,0.08), 0 14px 16px -6px rgba(34,34,43,0.10), 0 4px 22px 0 rgba(34,34,43,0.10)',
    z5: '0 6px 16px 0 rgba(34,34,43,0.08), 0 8px 24px 0 rgba(34,34,43,0.16), 0 18px 36px 0 rgba(34,34,43,0.08)',
    zNav: '0 1px 0 0 rgba(240, 240, 240, 1)',
};
exports.RADIUS = {
    s100: '2px',
    s200: '4px',
    s300: '8px',
    s400: '100%',
};
exports.SPACING = {
    s025: '.125rem',
    s050: '.25rem',
    s100: '.5rem',
    s150: '.75rem',
    s200: '1rem',
    s300: '1.5rem',
    s400: '2rem',
    s500: '2.5rem',
    s600: '3rem',
    s700: '3.5rem',
    s800: '4rem',
    s900: '4.5rem',
    s1000: '5rem',
};
exports.COLORS = {
    neutral: {
        n0: '#ffffff',
        n50: '#f7f7f7',
        n100: '#e1e1e4',
        n200: '#c8c8ca',
        n300: '#a2a2a7',
        n500: '#75757a',
        n600: '#69696f',
        n700: '#464650',
        n800: '#22222b',
        n900: '#121217',
    },
    gradient: {
        peach: 'radial-gradient(137.5% 368.39% at 74.71% -13.37%, #EC008C 0%, #E7A541 82.37%)',
        pinkDusk: 'linear-gradient(235deg, #EC008C 14.1%, #EA51A3 85.9%)',
        eggPlant: 'radial-gradient(137.5% 368.39% at 74.71% -13.37%, #990099 0%, #EC008C 82.37%)',
        sunset: 'linear-gradient(235deg, #EC008C 14.1%, #990099 85.9%)',
        sunrise: 'linear-gradient(235deg, #FFA500 14.1%, #E55253 85.9%)',
        midnightBlack: 'linear-gradient(235deg, #22222B 14.1%, #000000 85.9%)',
        charcoal: 'linear-gradient(119.43deg, #000000 35.82%, #979797 101.66%)',
        lime: 'linear-gradient(235deg, #0BA100 14.1%, #3FC636 85.9%)',
        northemLights: 'linear-gradient(235deg, #00C495 14.1%, #0089EC 85.9%)',
        lavender: 'linear-gradient(284.59deg, rgba(78, 65, 231, 0.2) -49.7%, rgba(78, 65, 231, 0.05) 59.76%)',
    },
    business: {
        fashion: {
            light: '#fee3e7',
            default: '#f85572',
            dark: '#c6445b',
        },
        food: {
            light: '#fff2d9',
            default: '#ffa500',
            dark: '#cc8400',
        },
        home: {
            light: '#f2dfef',
            default: '#aa2a92',
            dark: '#882275',
        },
        kids: {
            light: '#f1ebff',
            default: '#a378fd',
            dark: '#8260ca',
        },
        showtime: {
            light: '#d9f7f4',
            default: '#00ccb7',
            dark: '#00a392',
        },
        sport: {
            light: '#ddf7fc',
            default: '#1fc8ee',
            dark: '#19a0be',
        },
        travel: {
            light: '#e5eaff',
            default: '#5072fc',
            dark: '#405bca',
        },
    },
    functional: {
        success: {
            light: '#ebf6eb',
            default: '#048129',
        },
        error: {
            light: '#ffd8d8',
            default: '#c4201b',
        },
        informative: {
            light: '#d6ffff',
            default: '#00808a',
        },
        warning: {
            light: '#ffeec8',
            default: '#b25100',
        },
        pedagocical: {
            light: '#eeedfb',
            default: '#4e41e7',
        },
        discount: {
            base: '#3fae3',
            premium: '#f1d776',
            savings: '#3fae3e',
        },
    },
    guidedTour: {
        default: '#4e41e7',
    },
};
